export default __webpack_public_path__ + "static/media/TUPALO.78f56949.png";